import axios from "axios";
import { AuthReferences } from "@iloq/shared-vue";

export function useAxiosInstance() {
  const axiosInstance = axios.create();
  AuthReferences.setAuthInterceptors(axiosInstance);
  AuthReferences.setVersionInterceptor(axiosInstance);
  return axiosInstance;
}
